import React from 'react'

import styles from './Cart.module.css'

const EmptyCart = () => (
  <div className={styles['empty-cart']}>
    <img src={require('../../assets/images/cart/cart-none.png')} alt="empty" className={styles.icon} />
    <div className={styles['empty-text']}>当前购物袋为空</div>
  </div>
)

export default EmptyCart
